/* eslint-disable react/self-closing-comp */
import ArenaTrophiesCard from '../../components/arena/arena-trophies-card';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import BrandPartners from '../../components/brand-live/brand-partners';
import CreatorPromoTab from '../../components/brand-live/creator-promo-tab';
import { BrandLiveRateCard, getBrandLiveRateCard } from '../../api/payment/brand-live.api';
import ProfileBanner from '../../components/profile-banner/profile-banner.component';
import { usePostUser } from '../../hooks/post/usePostUser';
import _toString from 'lodash/toString';
import { useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import { ProfilePage, tabLabels } from '../profile/profile.page';
import { useUserProfile } from '../../hooks/profile/use-profile';
import { size } from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../components/loading/loading.component';
import { Post } from '../../components';
import UkSlider from '../../components/slider/uk-slider.component';
import { ChevronDown, HandCoins, Lock } from 'lucide-react';
import { fetchLeaderboardUserApi } from '../../api/user-profile/leaderboard';
import CreatorDonateLog from './components/creator-donate-log';
import CreatorSpinWheel from './components/creator-spin-wheel';
import CreatorLiveEffect from './components/creator-live-effect';
import CreatorDonateGoal from './components/creator-donate-goal';
import CreatorDonateChallenge from './components/creator-donate-challenge';
import CreatorSubathon from './components/creator-subathon';
import CreatorMusicRequest from './components/creator-music-request';
import AiQuestionAsk from '../../components/ai-question/ai-question-ask';
import CreatorDonatePoll from './components/creator-donate-poll';
import { getUserDonateSettingsByUserID } from '../../api/user-profile/user-profile.api';
import { getPublicDonateGoal } from '../../api/payment/donate-goal.api';
import { getPublicDonatePoll } from '../../api/payment/donate-poll.api';
import { getPublicSpinWheel } from '../../api/payment/spin-wheel.api';
import dayjs from 'dayjs';
import CreatorAdCard from '../../components/ads/creator-ad-card';
import { renderDate, RenderGender } from '../profile/components/Timeline';
import { FriendPage } from '../friend';
import { DialogTop } from '../user-setting/tabs/dialog-top';
import { TrapeziumButton } from '../../components/buton-trapezium';
import { CustomDropdown } from '../user-setting/tabs/custom-dropdown';
import Active from '../../images/profile/active-top.png';
import Disable from '../../images/profile/disable-top.png';
import SectionTabs, { SectionTabItem } from '../../components/section-tabs/section-tabs';
import { resolveActiveTab, visibleViewerTabs } from '../../utils/section-tabs';
import CreatorCollabTab from '../../components/brand-deal/brand-profile/creator-collab-tab';
import { useCreatorBrandProfile } from '../../hooks/use-creator-brand-profile';
import { BRAND_COLLAB_TAB, BRAND_PROFILE_COPY } from '../../utils/brand-profile';

// Thao tác donate (trang cá nhân người khác): thanh tab param `donate` (khác `?tab=` mà
// trang cá nhân của mình đang dùng cho các tab lớn, tránh đụng nhau). Thứ tự hiện theo đây,
// chỉ tính năng đang bật mới thành tab.
const DONATE_SUB_TAB_ORDER = ['hieu-ung', 'nhac', 'hoi-ai', 'binh-chon', 'vong-quay', 'lich-su'];
const DONATE_SUB_TAB_LABELS: Record<string, string> = {
  'hieu-ung': 'Hiệu ứng',
  nhac: 'Gửi nhạc',
  'hoi-ai': 'Hỏi AI',
  'binh-chon': 'Bình chọn',
  'vong-quay': 'Vòng quay',
  'lich-su': 'Lịch sử donate',
};

// Thẻ quảng cáo trên dòng thời gian: sau bài thứ 2, rồi cứ mỗi 6 bài.
const showProfileAd = (index: number) => index === 1 || (index > 1 && (index - 1) % 6 === 0);

export const ProfileUserPage = () => {
  const { userId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const myProfile = useSelector((state: RootState) => state.features.auth.profile);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const toggleDropdown = () => setIsDropdownVisible(!isDropdownVisible);
  const [activeTab, setActiveTab] = useState('timeline');
  const [leaderboard, setLeaderboard] = useState<any>();
  // Streamer có thể tự ẩn lịch sử donate công khai. Cờ này chỉ ẩn phần lịch sử và
  // bảng Top Donate; mục tiêu, bình chọn, vòng quay vẫn hiện nếu đang bật.
  const [hideDonateLog, setHideDonateLog] = useState(false);
  // Bảng giá quảng bá của creator; null (máy chủ trả 404) = không nhận quảng cáo ⇒ không có tab "Quảng bá".
  const [promoCard, setPromoCard] = useState<BrandLiveRateCard | null>(null);
  // Có mục tiêu / bình chọn / vòng quay nào đang bật không. Chỉ cần biết khi lịch sử bị ẩn:
  // lúc đó tab Donate chỉ hiện nếu còn ít nhất một mục, để tab không bị trống.
  const [hasDonateExtras, setHasDonateExtras] = useState(false);
  // Từng khối thao tác donate (nhạc/hỏi AI/bình chọn/vòng quay) tự báo có đang hiện hay
  // không (feature streamer có bật không) qua onAvailableChange -> quyết định có tab nào.
  const [donateFeatureAvailable, setDonateFeatureAvailable] = useState<
    Record<string, boolean | undefined>
  >({});
  const handleDonateFeatureAvailable = (key: string) => (value: boolean) => {
    setDonateFeatureAvailable((prev) =>
      prev[key] === value ? prev : { ...prev, [key]: value }
    );
  };
  const donateAvailability: Record<string, boolean | undefined> = {
    ...donateFeatureAvailable,
    'lich-su': !hideDonateLog,
  };
  const donateVisibleTabs = visibleViewerTabs(donateAvailability, DONATE_SUB_TAB_ORDER);
  const donateRequestedTab = searchParams.get('donate');
  // KHÔNG ghi `?donate=` từ effect: nếu ghi ngay khi mount (trước khi 4 tính năng kịp báo
  // available), sẽ chốt cứng tab mặc định là phần tử available sớm nhất lúc đó (thường là
  // lịch sử, luôn available ngay) thay vì tính năng đầu tiên đang bật theo đúng thiết kế.
  // Chỉ ghi URL khi người xem tự bấm chọn tab (xem handleDonateTabChange) — không thì để
  // resolveActiveTab tự theo tính năng đầu tiên đang hiện, tab tự "trôi" đúng theo khi dữ
  // liệu load xong, và khi tab đang chọn biến mất thì tự rơi về tab đầu còn lại.
  const donateActiveTab = donateVisibleTabs.length
    ? resolveActiveTab(donateVisibleTabs, donateRequestedTab, donateVisibleTabs[0])
    : null;
  const [activeTabLeaderboard, setActiveTabLeaderboard] = useState('donator');
  const [isOpenFullTop, setIsOpenFullTop] = useState<boolean>(false);
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
  const [isCurrent, setIsCurrent] = useState<boolean>(true);
  const currencyFormatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  });
  const handleClick = (tabName) => {
    handleTabClick(tabName);
    toggleDropdown();
  };
  const handleTabClick = (tabName) => {
    setActiveTabLeaderboard(tabName);
  };
  const changeTag = (tab) => {
    setActiveTab(tab);
  };
  const { profile, getUserProfile } = useUserProfile(_toString(userId));

  // Tab "Hợp tác" (spec 2026-10-12 §4): chỉ hiện khi creator có đánh giá đã công bố hoặc đang nhận đơn.
  const collab = useCreatorBrandProfile(profile?.userId);
  const tabParam = searchParams.get('tab');
  useEffect(() => {
    if (collab?.visible) {
      if (tabParam === BRAND_COLLAB_TAB) setActiveTab(BRAND_COLLAB_TAB);
    } else {
      setActiveTab((t) => (t === BRAND_COLLAB_TAB ? 'timeline' : t));
    }
  }, [collab?.visible, tabParam]);

  const [pageNumber, setPageNumber] = useState<number>(1);

  const { data: listPost, hasMore } = usePostUser({
    pageNumber,
    userId: profile?.userId || '',
  });

  // Leaderboard theo user: chạy khi profile đã load. PHẢI dùng userId (Guid) — endpoint
  // statistical-donate nhận param UserId kiểu Guid, truyền username sẽ trả HTTP 400
  // (lấy từ profile đã load nên vẫn không phụ thuộc URL là slug hay email cũ).
  useEffect(() => {
    if (!profile?.userId) return;
    getUserDonateSettingsByUserID(profile.userId)
      .then((res) => setHideDonateLog(!!res?.hideDonationLog))
      .catch(() => setHideDonateLog(false)); // lỗi đọc cài đặt -> giữ mặc định là hiện
  }, [profile?.userId]);

  useEffect(() => {
    setPromoCard(null);
    setActiveTab((t) => (t === 'promo' ? 'timeline' : t));
    if (!profile?.userId || profile.userId === myProfile?.userId) return;
    let alive = true;
    getBrandLiveRateCard(profile.userId)
      .then((c) => {
        if (!alive) return;
        setPromoCard(c ?? null);
        if (!c) setActiveTab((t) => (t === 'promo' ? 'timeline' : t));
      })
      .catch(() => {
        if (!alive) return;
        setPromoCard(null);
        setActiveTab((t) => (t === 'promo' ? 'timeline' : t));
      });
    return () => {
      alive = false;
    };
  }, [profile?.userId, myProfile?.userId]);

  useEffect(() => {
    if (!profile?.userId || !hideDonateLog) {
      setHasDonateExtras(false);
      return undefined;
    }
    const id = profile.userId;
    let cancelled = false;
    // Điều kiện khớp với lúc từng khối tự quyết định hiện hay ẩn.
    Promise.all([
      getPublicDonateGoal(id)
        .then((g) => !!g?.exists)
        .catch(() => false),
      getPublicDonatePoll(id)
        .then((p) => !!p?.exists && !!p.isActive)
        .catch(() => false),
      getPublicSpinWheel(id)
        .then((w) => !!w?.exists && !!w.isActive && !!w.items?.length)
        .catch(() => false),
    ]).then((flags) => {
      if (!cancelled) setHasDonateExtras(flags.some(Boolean));
    });
    return () => {
      cancelled = true;
    };
  }, [profile?.userId, hideDonateLog]);

  useEffect(() => {
    if (!profile?.userId) return;
    const fetchLeaderboard = async () => {
      try {
        const response = await fetchLeaderboardUserApi(profile.userId);
        setLeaderboard(response);
      } catch (error) {
        console.error('Failed to fetch leaderboard:', error);
      }
    };
    fetchLeaderboard();
  }, [profile?.userId]);

  const onContactSuccess = () => {
    getUserProfile();
  };

  if (!profile) {
    return null;
  }

  const {
    description,
    categoryFavorites,
    city,
    isShowMarry,
    company,
    school,
    marry,
  } = profile;

  // Lịch sử donate CÔNG KHAI của creator (ai donate, lời nhắn, bao nhiêu Ca).
  // Khối cũ gọi donation-history theo token nên hiện nhầm dữ liệu của CHÍNH người
  // đang xem; nay dùng endpoint public theo userId của creator.
  const renderTabDonate = () => {
    if (!profile?.canReceiveDonation) {
      return (
        <div className="flex flex-col justify-center items-center h-fix mt-10 box py-4">
          <Lock size={50} />
          <p className="text-sm text-gray-500 mt-2 dark:text-white/80 p-5">
            Người dùng này chưa mở nhận donate.
          </p>
        </div>
      );
    }
    const donateTabs: SectionTabItem[] = donateVisibleTabs.map((key) => ({
      key,
      label: DONATE_SUB_TAB_LABELS[key] || key,
    }));
    const handleDonateTabChange = (key: string) => {
      const next = new URLSearchParams(searchParams);
      next.set('donate', key);
      setSearchParams(next, { replace: true });
    };

    return (
      <>
        {/* Giữ trên đầu, không vào tab: tổng quan donate (thử thách + mục tiêu + subathon). */}
        <CreatorSubathon userId={profile?.userId} />
        <CreatorDonateChallenge userId={profile?.userId} />
        <CreatorDonateGoal userId={profile?.userId} />

        {/* Chỉ hiện thanh tab khi có từ 2 tính năng trở lên — 1 tính năng thì hiện thẳng, khỏi
            vẽ thanh tab chỉ để bấm 1 nút. */}
        {donateTabs.length > 1 && (
          <SectionTabs
            tabs={donateTabs}
            active={donateActiveTab || donateTabs[0].key}
            onChange={handleDonateTabChange}
          />
        )}

        {/* Luôn render cả 5 panel (dù đang ẩn) để chúng tự tải dữ liệu + báo tính năng có đang
            bật hay không; ẩn bằng `hidden` (không unmount) để không mất ô nhập dở khi đổi tab. */}
        <div hidden={donateActiveTab !== 'nhac'}>
          <CreatorMusicRequest
            userId={profile?.userId}
            onAvailableChange={handleDonateFeatureAvailable('nhac')}
          />
        </div>
        <div hidden={donateActiveTab !== 'hoi-ai'}>
          <AiQuestionAsk
            userId={profile?.userId}
            onAvailableChange={handleDonateFeatureAvailable('hoi-ai')}
          />
        </div>
        <div hidden={donateActiveTab !== 'binh-chon'}>
          <CreatorDonatePoll
            userId={profile?.userId}
            onAvailableChange={handleDonateFeatureAvailable('binh-chon')}
          />
        </div>
        <div hidden={donateActiveTab !== 'hieu-ung'}>
          <CreatorLiveEffect
            userId={profile?.userId}
            creatorName={profile?.fullname || profile?.username || ''}
            onAvailableChange={handleDonateFeatureAvailable('hieu-ung')}
          />
        </div>
        <div hidden={donateActiveTab !== 'vong-quay'}>
          <CreatorSpinWheel
            userId={profile?.userId}
            onAvailableChange={handleDonateFeatureAvailable('vong-quay')}
          />
        </div>
        {!hideDonateLog && (
          <div hidden={donateActiveTab !== 'lich-su'}>
            <CreatorDonateLog userId={profile?.userId} />
          </div>
        )}
      </>
    );
  };

  const renderContent = (tabActive: string) => {
    switch (tabActive) {
      case 'timeline':
        return (
          <div className="flex flex-col gap-[10px]">
            {size(listPost) ? (
              <InfiniteScroll
                dataLength={listPost.length}
                next={() => {
                  setPageNumber((prev) => prev + 1);
                }}
                hasMore={hasMore}
                loader={<Loading classname="mx-auto" />}
                endMessage={null}
                scrollableTarget="body"
              >
                <div className="flex-1 xl:space-y-6 space-y-3">
                  {listPost?.map((post, index) => {
                    return (
                      <React.Fragment key={post.id}>
                        <Post post={post} />
                        {profile?.userId && showProfileAd(index) ? (
                          <CreatorAdCard
                            key={`ad-${index}`}
                            placement="Profile"
                            creatorId={profile.userId}
                          />
                        ) : null}
                      </React.Fragment>
                    );
                  })}
                </div>
              </InfiniteScroll>
            ) : null}

            {!size(listPost) ? (
              <p className="text-sm text-slate-800 userDonates:text-slate-50 font-medium text-center mt-10">
                Chưa có bài viết nào
              </p>
            ) : null}
          </div>
        );

      case 'friend':
        return <FriendPage />;

      case 'history-donate':
        return renderTabDonate();
      case 'promo':
        return promoCard && profile?.userId ? (
          <CreatorPromoTab
            creatorId={profile.userId}
            creatorName={profile.fullname || profile.username || ''}
            rateCard={promoCard}
            loggedIn={!!myProfile?.userId}
          />
        ) : null;
      case BRAND_COLLAB_TAB:
        return collab?.visible && profile?.userId ? (
          <CreatorCollabTab creatorId={profile.userId} profile={collab} isOwner={false} />
        ) : null;
      default:
        return null;
    }
  };

  // Nếu đây chính là hồ sơ của mình → render trang cá nhân ĐẦY ĐỦ (có sửa + tab Cài đặt),
  // nhưng URL vẫn là /user/{handle} (link cá nhân chia sẻ được).
  if (profile?.userId && myProfile?.userId && profile.userId === myProfile.userId) {
    return <ProfilePage />;
  }

  return (
    <div className="w-full max-lg:-m-2.5 bg-white dark:bg-dark2">
      <Helmet>
        <title>{profile?.fullname || 'Người dùng'} - Cab</title>
        <meta name="description" content={description} />
      </Helmet>
      <ProfileBanner
        profile={profile}
        userId={userId}
        onUpdateSuccess={() => {
          //
        }}
        tabActive={activeTab}
        changeTab={changeTag}
        onContactSuccess={onContactSuccess}
      />
      <div className="flex-1 xl:space-y-6 space-y-3">
        <div className="flex 2xl:gap-12 2xl:px-12 gap-6 mt-3  max-lg:flex-col bg-white px-6 dark:bg-dark2 pb-6">
          <div className="lg:w-[306px]">
            <div className="lg:space-y-4 lg:pb-8 max-lg:grid sm:grid-cols-2 max-lg:gap-6 uk-sticky uk-active uk-sticky-fixed">
              <div className="border border-[#DEE0E6] dark:border-slate-700 rounded-xl lg:-translate-y-[150px]">
                {profile.description && (
                  <div className=" border-b p-3 text-sm truncate">
                    {description}
                  </div>
                )}
                <h3 className="font-semibold text-[22px] p-3 "> Giới thiệu </h3>
                <ul className="text-gray-700  p-3 text-sm dark:text-white/80">
                  <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.7467 5.63317C13.0467 2.55317 10.3601 1.1665 8.00006 1.1665C8.00006 1.1665 8.00006 1.1665 7.9934 1.1665C5.64006 1.1665 2.94673 2.5465 2.24673 5.6265C1.46673 9.0665 3.5734 11.9798 5.48006 13.8132C6.18673 14.4932 7.0934 14.8332 8.00006 14.8332C8.90673 14.8332 9.8134 14.4932 10.5134 13.8132C12.4201 11.9798 14.5267 9.07317 13.7467 5.63317ZM8.00006 8.97317C6.84006 8.97317 5.90006 8.03317 5.90006 6.87317C5.90006 5.71317 6.84006 4.77317 8.00006 4.77317C9.16006 4.77317 10.1001 5.71317 10.1001 6.87317C10.1001 8.03317 9.16006 8.97317 8.00006 8.97317Z"
                        fill="#657384"
                      />
                    </svg>
                    <div className="flex">
                      {city ? (
                        <>
                          Đến từ&nbsp;
                          <p className="font-semibold text-black dark:text-white">{city}</p>
                        </>
                      ) : (
                        <p className="font-normal">Chưa cập nhật nơi sống</p>
                      )}
                    </div>
                  </li>
                  {profile.schools && profile.schools.length > 0 ? (
                    profile.schools.map((item, index) => (
                      <li
                        key={`${item.workPlaceName}-${index}`}
                        className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1"
                      >
                        <div className="pt-[2px]">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.6673 10.6667V12.3333C13.6673 13.62 12.6207 14.6667 11.334 14.6667H4.66732C3.38065 14.6667 2.33398 13.62 2.33398 12.3333V11.9C2.33398 10.8533 3.18732 10 4.23398 10H13.0007C13.3673 10 13.6673 10.3 13.6673 10.6667Z"
                              fill="#657384"
                            />
                            <path
                              d="M10.334 1.3335H5.66732C3.00065 1.3335 2.33398 2.00016 2.33398 4.66683V9.72016C2.84065 9.2735 3.50732 9.00016 4.23398 9.00016H13.0007C13.3673 9.00016 13.6673 8.70016 13.6673 8.3335V4.66683C13.6673 2.00016 13.0007 1.3335 10.334 1.3335ZM8.66732 7.16683H5.33398C5.06065 7.16683 4.83398 6.94016 4.83398 6.66683C4.83398 6.3935 5.06065 6.16683 5.33398 6.16683H8.66732C8.94065 6.16683 9.16732 6.3935 9.16732 6.66683C9.16732 6.94016 8.94065 7.16683 8.66732 7.16683ZM10.6673 4.8335H5.33398C5.06065 4.8335 4.83398 4.60683 4.83398 4.3335C4.83398 4.06016 5.06065 3.8335 5.33398 3.8335H10.6673C10.9407 3.8335 11.1673 4.06016 11.1673 4.3335C11.1673 4.60683 10.9407 4.8335 10.6673 4.8335Z"
                              fill="#657384"
                            />
                          </svg>
                        </div>
                        <div className="flex gap-[10px] flex-col">
                          <div className="flex items-center">
                            Học tại&nbsp;
                            <span className="font-bold truncate ">
                              {item.workPlaceName}
                            </span>
                          </div>
                          <span className="text-xs text-[#657384]">
                            [{renderDate(item.from)}-{renderDate(item.to)}]
                          </span>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.6673 10.6667V12.3333C13.6673 13.62 12.6207 14.6667 11.334 14.6667H4.66732C3.38065 14.6667 2.33398 13.62 2.33398 12.3333V11.9C2.33398 10.8533 3.18732 10 4.23398 10H13.0007C13.3673 10 13.6673 10.3 13.6673 10.6667Z"
                          fill="#657384"
                        />
                        <path
                          d="M10.334 1.3335H5.66732C3.00065 1.3335 2.33398 2.00016 2.33398 4.66683V9.72016C2.84065 9.2735 3.50732 9.00016 4.23398 9.00016H13.0007C13.3673 9.00016 13.6673 8.70016 13.6673 8.3335V4.66683C13.6673 2.00016 13.0007 1.3335 10.334 1.3335ZM8.66732 7.16683H5.33398C5.06065 7.16683 4.83398 6.94016 4.83398 6.66683C4.83398 6.3935 5.06065 6.16683 5.33398 6.16683H8.66732C8.94065 6.16683 9.16732 6.3935 9.16732 6.66683C9.16732 6.94016 8.94065 7.16683 8.66732 7.16683ZM10.6673 4.8335H5.33398C5.06065 4.8335 4.83398 4.60683 4.83398 4.3335C4.83398 4.06016 5.06065 3.8335 5.33398 3.8335H10.6673C10.9407 3.8335 11.1673 4.06016 11.1673 4.3335C11.1673 4.60683 10.9407 4.8335 10.6673 4.8335Z"
                          fill="#657384"
                        />
                      </svg>
                      <div className="flex items-center">
                        Chưa cập nhật nơi học
                      </div>
                    </li>
                  )}

                  {profile.companies && profile.companies.length > 0 ? (
                    profile.companies.map((item, index) => (
                      <li
                        key={`${item.workPlaceName}-${index}`}
                        className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1"
                      >
                        <div className="pt-[2px]">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.6673 10.6667V12.3333C13.6673 13.62 12.6207 14.6667 11.334 14.6667H4.66732C3.38065 14.6667 2.33398 13.62 2.33398 12.3333V11.9C2.33398 10.8533 3.18732 10 4.23398 10H13.0007C13.3673 10 13.6673 10.3 13.6673 10.6667Z"
                              fill="#657384"
                            />
                            <path
                              d="M10.334 1.3335H5.66732C3.00065 1.3335 2.33398 2.00016 2.33398 4.66683V9.72016C2.84065 9.2735 3.50732 9.00016 4.23398 9.00016H13.0007C13.3673 9.00016 13.6673 8.70016 13.6673 8.3335V4.66683C13.6673 2.00016 13.0007 1.3335 10.334 1.3335ZM8.66732 7.16683H5.33398C5.06065 7.16683 4.83398 6.94016 4.83398 6.66683C4.83398 6.3935 5.06065 6.16683 5.33398 6.16683H8.66732C8.94065 6.16683 9.16732 6.3935 9.16732 6.66683C9.16732 6.94016 8.94065 7.16683 8.66732 7.16683ZM10.6673 4.8335H5.33398C5.06065 4.8335 4.83398 4.60683 4.83398 4.3335C4.83398 4.06016 5.06065 3.8335 5.33398 3.8335H10.6673C10.9407 3.8335 11.1673 4.06016 11.1673 4.3335C11.1673 4.60683 10.9407 4.8335 10.6673 4.8335Z"
                              fill="#657384"
                            />
                          </svg>
                        </div>

                        <div className="flex gap-[10px] flex-col">
                          <div className="flex items-center">
                            Làm việc tại&nbsp;
                            <span className="font-bold truncate">
                              {item.workPlaceName}
                            </span>
                          </div>
                          <span className="text-xs text-[#657384]">
                            [{renderDate(item.from)}-{renderDate(item.to)}]
                          </span>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.6673 10.6667V12.3333C13.6673 13.62 12.6207 14.6667 11.334 14.6667H4.66732C3.38065 14.6667 2.33398 13.62 2.33398 12.3333V11.9C2.33398 10.8533 3.18732 10 4.23398 10H13.0007C13.3673 10 13.6673 10.3 13.6673 10.6667Z"
                          fill="#657384"
                        />
                        <path
                          d="M10.334 1.3335H5.66732C3.00065 1.3335 2.33398 2.00016 2.33398 4.66683V9.72016C2.84065 9.2735 3.50732 9.00016 4.23398 9.00016H13.0007C13.3673 9.00016 13.6673 8.70016 13.6673 8.3335V4.66683C13.6673 2.00016 13.0007 1.3335 10.334 1.3335ZM8.66732 7.16683H5.33398C5.06065 7.16683 4.83398 6.94016 4.83398 6.66683C4.83398 6.3935 5.06065 6.16683 5.33398 6.16683H8.66732C8.94065 6.16683 9.16732 6.3935 9.16732 6.66683C9.16732 6.94016 8.94065 7.16683 8.66732 7.16683ZM10.6673 4.8335H5.33398C5.06065 4.8335 4.83398 4.60683 4.83398 4.3335C4.83398 4.06016 5.06065 3.8335 5.33398 3.8335H10.6673C10.9407 3.8335 11.1673 4.06016 11.1673 4.3335C11.1673 4.60683 10.9407 4.8335 10.6673 4.8335Z"
                          fill="#657384"
                        />
                      </svg>
                      <div className="flex items-center">
                        Chưa cập nhật nơi làm việc
                      </div>
                    </li>
                  )}
                  <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.6467 1.55317C14.1667 1.0065 13.4533 0.666504 12.6667 0.666504C11.92 0.666504 11.24 0.973171 10.7533 1.47317C10.4733 1.75984 10.26 2.1065 10.1333 2.49317C10.0467 2.75984 10 3.03984 10 3.33317C10 3.83317 10.14 4.3065 10.3867 4.7065C10.52 4.93317 10.6933 5.13984 10.8933 5.31317C11.36 5.73984 11.98 5.99984 12.6667 5.99984C12.96 5.99984 13.24 5.95317 13.5 5.85984C14.1133 5.6665 14.6267 5.2465 14.9467 4.7065C15.0867 4.47984 15.1933 4.21984 15.2533 3.95317C15.3067 3.75317 15.3333 3.5465 15.3333 3.33317C15.3333 2.65317 15.0733 2.0265 14.6467 1.55317ZM13.66 3.81984H13.1667V4.33984C13.1667 4.61317 12.94 4.83984 12.6667 4.83984C12.3933 4.83984 12.1667 4.61317 12.1667 4.33984V3.81984H11.6733C11.4 3.81984 11.1733 3.59317 11.1733 3.31984C11.1733 3.0465 11.4 2.81984 11.6733 2.81984H12.1667V2.3465C12.1667 2.07317 12.3933 1.8465 12.6667 1.8465C12.94 1.8465 13.1667 2.07317 13.1667 2.3465V2.81984H13.66C13.9333 2.81984 14.16 3.0465 14.16 3.31984C14.16 3.59317 13.94 3.81984 13.66 3.81984Z"
                        fill="#657384"
                      />
                      <path
                        d="M14.6673 8.00016C14.6673 7.12683 14.5007 6.28683 14.1873 5.52016C13.9807 5.66683 13.7473 5.78016 13.5007 5.86016C13.4273 5.88683 13.354 5.90683 13.274 5.92683C13.5273 6.56683 13.6673 7.26683 13.6673 8.00016C13.6673 9.54683 13.0407 10.9535 12.0273 11.9802C11.834 11.7335 11.5873 11.5068 11.294 11.3135C9.48732 10.1002 6.52732 10.1002 4.70732 11.3135C4.41398 11.5068 4.17398 11.7335 3.97398 11.9802C2.96065 10.9535 2.33398 9.54683 2.33398 8.00016C2.33398 4.8735 4.87398 2.3335 8.00065 2.3335C8.72732 2.3335 9.42732 2.4735 10.0673 2.72683C10.0873 2.64683 10.1073 2.5735 10.134 2.4935C10.214 2.24683 10.3273 2.02016 10.4807 1.8135C9.71398 1.50016 8.87398 1.3335 8.00065 1.3335C4.32732 1.3335 1.33398 4.32683 1.33398 8.00016C1.33398 9.9335 2.16732 11.6735 3.48732 12.8935C3.48732 12.9002 3.48732 12.9002 3.48065 12.9068C3.54732 12.9735 3.62732 13.0268 3.69398 13.0868C3.73398 13.1202 3.76732 13.1535 3.80732 13.1802C3.92732 13.2802 4.06065 13.3735 4.18732 13.4668C4.23398 13.5002 4.27398 13.5268 4.32065 13.5602C4.44732 13.6468 4.58065 13.7268 4.72065 13.8002C4.76732 13.8268 4.82065 13.8602 4.86732 13.8868C5.00065 13.9602 5.14065 14.0268 5.28732 14.0868C5.34065 14.1135 5.39398 14.1402 5.44732 14.1602C5.59398 14.2202 5.74065 14.2735 5.88732 14.3202C5.94065 14.3402 5.99398 14.3602 6.04732 14.3735C6.20732 14.4202 6.36732 14.4602 6.52732 14.5002C6.57398 14.5135 6.62065 14.5268 6.67398 14.5335C6.86065 14.5735 7.04732 14.6002 7.24065 14.6202C7.26732 14.6202 7.29398 14.6268 7.32065 14.6335C7.54732 14.6535 7.77398 14.6668 8.00065 14.6668C8.22732 14.6668 8.45398 14.6535 8.67398 14.6335C8.70065 14.6335 8.72732 14.6268 8.75398 14.6202C8.94732 14.6002 9.13398 14.5735 9.32065 14.5335C9.36732 14.5268 9.41398 14.5068 9.46732 14.5002C9.62732 14.4602 9.79398 14.4268 9.94732 14.3735C10.0007 14.3535 10.054 14.3335 10.1073 14.3202C10.254 14.2668 10.4073 14.2202 10.5473 14.1602C10.6007 14.1402 10.654 14.1135 10.7073 14.0868C10.8473 14.0268 10.9873 13.9602 11.1273 13.8868C11.1807 13.8602 11.2273 13.8268 11.274 13.8002C11.4073 13.7202 11.5407 13.6468 11.674 13.5602C11.7207 13.5335 11.7607 13.5002 11.8073 13.4668C11.9407 13.3735 12.0673 13.2802 12.1873 13.1802C12.2273 13.1468 12.2607 13.1135 12.3007 13.0868C12.374 13.0268 12.4473 12.9668 12.514 12.9068C12.514 12.9002 12.514 12.9002 12.5073 12.8935C13.834 11.6735 14.6673 9.9335 14.6673 8.00016Z"
                        fill="#657384"
                      />
                      <path
                        d="M8 4.62012C6.62 4.62012 5.5 5.74012 5.5 7.12012C5.5 8.47345 6.56 9.57345 7.96667 9.61345C7.98667 9.61345 8.01333 9.61345 8.02667 9.61345C8.04 9.61345 8.06 9.61345 8.07333 9.61345C8.08 9.61345 8.08667 9.61345 8.08667 9.61345C9.43333 9.56678 10.4933 8.47345 10.5 7.12012C10.5 5.74012 9.38 4.62012 8 4.62012Z"
                        fill="#657384"
                      />
                    </svg>

                    <div className="flex items-center">
                      Giới tính&nbsp;
                      <RenderGender gender={profile.sex} />
                    </div>
                  </li>
                  <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                    <svg
                      width="14"
                      height="12"
                      viewBox="0 0 14 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.96065 0.0668945C8.75399 0.0668945 7.67398 0.653561 7.00065 1.55356C6.32732 0.653561 5.24732 0.0668945 4.04065 0.0668945C1.99398 0.0668945 0.333984 1.73356 0.333984 3.79356C0.333984 4.58689 0.460651 5.32023 0.680651 6.00023C1.73398 9.33356 4.98065 11.3269 6.58732 11.8736C6.81398 11.9536 7.18732 11.9536 7.41398 11.8736C9.02065 11.3269 12.2673 9.33356 13.3207 6.00023C13.5407 5.32023 13.6673 4.58689 13.6673 3.79356C13.6673 1.73356 12.0073 0.0668945 9.96065 0.0668945Z"
                        fill="#657384"
                      />
                    </svg>
                    <div className="flex items-center">
                      Mối quan hệ&nbsp;
                      <span className="font-semibold text-black dark:text-white">
                        {profile.marry === 1 ? ' Kết Hôn' : ' Độc thân'}
                      </span>
                    </div>
                  </li>
                </ul>
                <ArenaTrophiesCard userId={profile?.userId} />
                <BrandPartners userId={profile?.userId} />
              </div>
            </div>
            <section>
              <div className="w-full -translate-y-[120px] ">
                <header
                  onClick={() => handleClick('donator')}
                  className={`relative cursor-pointer -top-8   [filter:url(#fancy-goooooo)]
                   ${activeTabLeaderboard === 'donator' ? 'z-10' : ' z-0'}
                  `}
                >
                  <div
                    className={`flex font-bold text-base items-center justify-center absolute whitespace-nowrap h-[22px] w-1/2  px-10 py-4  z-20  ${
                      activeTabLeaderboard === 'donator'
                        ? 'bg-gradient-to-b backdrop-blur-[20px] from-[#cbe0fb] via-[#EFEFEF] to-[#ffffff]'
                        : 'bg-gradient-to-b from-[#B2D1FF] via-[#2B8AE1] to-[#2B8AE1]'
                    }`}
                  >
                    Top Donate
                  </div>
                  <div
                    className={`absolute w-full border-l h-[40px] top-[30px]  backdrop-blur-[20px]  ${
                      activeTabLeaderboard === 'donator'
                        ? 'z-10 bg-white'
                        : ' z-0 bg-[#2B8AE1]'
                    }`}
                  />
                </header>
                <header
                  onClick={() => handleClick('react')}
                  className={`relative cursor-pointer shadow-2xl -top-8 z-0 [filter:url(#fancy-goooooo)]
                        ${
                          activeTabLeaderboard === 'react'
                            ? 'z-10 bg-[#1871F8]'
                            : ' z-0 bg-[#EFEFEF]'
                        }
                  `}
                >
                  <div
                    className={` flex font-bold text-base items-center justify-center absolute whitespace-nowrap right-0  h-[22px] w-1/2  px-10 py-4  rounded-lg ${
                      activeTabLeaderboard === 'react'
                        ? 'bg-gradient-to-b backdrop-blur-[20px] from-[#cbe0fb] via-[#EFEFEF] to-[#ffffff]'
                        : 'bg-gradient-to-b from-[#B2D1FF] via-[#2B8AE1] to-[#2B8AE1]'
                    }`}
                  >
                    Top tương tác
                  </div>
                  <div
                    className={`absolute w-full border-l h-[40px] top-[30px]  backdrop-blur-[20px]  ${
                      activeTabLeaderboard === 'react'
                        ? 'z-10 bg-white'
                        : ' z-0 bg-[#2B8AE1]'
                    }`}
                  />
                </header>

                <div className="relative flex flex-col gap-4 z-5 p-4 pt-10 bg-white backdrop-blur-[20px] border  rounded-[20px]">
                  <CustomDropdown
                    disable={isCurrent}
                    value={month.toString()}
                    options={Array.from({ length: 12 }, (_, i) => ({
                      label: `Tháng ${i + 1}`,
                      value: `${i + 1}`,
                    }))}
                    placeholder="Tháng"
                    customClassName="py-2 h-10 px-3 text-base font-semibold"
                    onChange={(val) => setMonth(Number(val))}
                  />

                  <div className="flex w-full justify-between">
                    <div
                      onClick={() => setIsCurrent(true)}
                      className=" cursor-pointer pl-2 py-[14px] relative w-full max-w-[126px] aspect-[126/79]"
                    >
                      <div className=" absolute inset-0">
                        <img
                          src={isCurrent ? Active : Disable}
                          alt="Top hiện tại"
                          className="w-full h-full"
                        />
                      </div>
                      <span
                        className={`relative text-base ${
                          isCurrent
                            ? 'font-semibold text-white'
                            : 'font-normal text-[#EDEDED]'
                        }`}
                      >
                        Top hiện tại
                      </span>
                    </div>
                    <div
                      onClick={() => setIsCurrent(false)}
                      className=" cursor-pointer pl-2 py-[14px] relative w-full max-w-[126px] aspect-[126/79]"
                    >
                      <div className=" absolute inset-0">
                        <img
                          src={!isCurrent ? Active : Disable}
                          alt="Top theo tháng"
                          className="w-full h-full"
                        />
                      </div>
                      <span
                        className={`relative text-base ${
                          !isCurrent
                            ? 'font-semibold text-white'
                            : 'font-normal text-[#EDEDED]'
                        }`}
                      >
                        Top theo tháng
                      </span>
                    </div>
                  </div>
                  {/* Cả hai bảng đều là người donate (theo số Ca / số lượt) nên cùng theo cờ ẩn lịch sử. */}
                  {hideDonateLog ? (
                    <p className="ui-muted text-sm text-center px-4 py-8">
                      Người này đã ẩn danh sách người donate.
                    </p>
                  ) : (
                    <>
                      {activeTabLeaderboard === 'react' && (
                        <UkSlider sliderItems={leaderboard?.topAction} memberCreatorId={profile?.userId} />
                      )}
                      {activeTabLeaderboard === 'donator' && (
                        <UkSlider sliderItems={leaderboard?.topMoney} memberCreatorId={profile?.userId} />
                      )}
                    </>
                  )}

                  <div className="absolute bottom-0 right-[20px] translate-y-[30px]">
                    {/* <TrapeziumButton onClick={() => setIsOpenFullTop(true)}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.1667 5.83301L5 14.9997"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M9.16602 5.1096C9.16602 5.1096 13.8606 4.71385 14.5731 5.42628C15.2855 6.1387 14.8897 10.8333 14.8897 10.8333"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="skew-x-[20deg]">Xem thêm</span>
                    </TrapeziumButton> */}
                    {isOpenFullTop && (
                      <DialogTop
                        handleClose={() => setIsOpenFullTop(false)}
                        open={isOpenFullTop}
                        monthCurrent={month}
                        current={isCurrent}
                        activeTabCurrent={activeTabLeaderboard}
                      />
                    )}
                  </div>
                </div>

                {/* SVG Filter */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  className="hidden"
                >
                  <defs>
                    <filter id="fancy-goooooo">
                      <feGaussianBlur
                        in="SourceGraphic"
                        stdDeviation="9"
                        result="blur"
                      />
                      <feColorMatrix
                        in="blur"
                        mode="matrix"
                        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                        result="goo"
                      />
                      <feComposite
                        in="SourceGraphic"
                        in2="goo"
                        operator="atop"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              {/* <div className="box p-5 px-6 border1 dark:bg-dark2">
                <div className="px-4 pb-4  rounded-b-lg   ">
                  <div className="flex justify-center text-black dark:text-white">
                    <div className="relative inline-flex">
                      <button
                        className="inline-flex items-center justify-center h-10 gap-2 px-5 text-sm font-medium tracking-wide text-primary transition duration-300 rounded focus-visible:outline-none whitespace-nowrap"
                        onClick={toggleDropdown}
                      >
                        <span>
                          {activeTabLeaderboard
                            ? tabLabels[activeTabLeaderboard]
                            : 'Select an option'}
                        </span>
                        <span
                          className="relative only:-mx-5"
                          style={{
                            transition: 'transform 0.3s ease',
                            transform: isDropdownVisible
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                          }}
                        >
                          <ChevronDown />
                        </span>
                      </button>
                      {isDropdownVisible && (
                        <ul className="absolute z-20 flex flex-col py-2 mt-1 list-none bg-white rounded shadow-md w-48 top-full shadow-slate-500/10 justify-center">
                          <li>
                            <button
                              onClick={() => handleClick('followers')}
                              className="flex items-start justify-start gap-2 p-2 px-5 transition-colors duration-300 text-slate-500 hover:bg-blue-50 hover:text-blue-600 focus:bg-blue-50 focus:text-blue-600 focus:outline-none focus-visible:outline-none w-full"
                            >
                              <span className="flex flex-col gap-1 overflow-hidden whitespace-nowrap">
                                <span className="leading-5 truncate">
                                  Top tương tác
                                </span>
                              </span>
                            </button>
                          </li>
                          <li>
                            <button
                              onClick={() => handleClick('donator')}
                              className=" flex items-start justify-start gap-2 p-2 px-5 overflow-hidden transition-colors duration-300 text-slate-500 hover:bg-blue-50 hover:text-blue-500 focus:bg-blue-50 focus:text-blue-600 focus:outline-none focus-visible:outline-none w-full"
                            >
                              <span className="flex flex-col gap-1 overflow-hidden whitespace-nowrap">
                                <span className="leading-5 truncate">
                                  Top Donator
                                </span>
                              </span>
                            </button>
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                  {activeTabLeaderboard === 'followers' && (
                    <UkSlider sliderItems={leaderboard?.topAction} />
                  )}
                  {activeTabLeaderboard === 'donator' && (
                    <UkSlider sliderItems={leaderboard?.topMoney} />
                  )}
                </div>
              </div> */}
            </section>
          </div>
          <div className="flex-1 xl:space-y-6 space-y-3">
            <nav className="flex gap-0.5 border-b border-[#C8CCD8] -mb-px text-gray-600 font-medium text-[15px]  dark:text-white max-md:w-full max-md:overflow-x-auto">
              <div
                className={`cursor-pointer  inline-block  py-3 leading-8 px-4 font-semibold text-base border-b-2   ${
                  activeTab === 'timeline'
                    ? 'border-[#234093] text-[#234093]'
                    : 'border-transparent'
                } `}
                onClick={() => setActiveTab('timeline')}
              >
                Bài viết
              </div>
              {profile?.canReceiveDonation && (!hideDonateLog || hasDonateExtras) && (
                <div
                  className={`cursor-pointer  inline-block  py-3 leading-8 px-4 font-semibold text-base border-b-2 ${
                    activeTab === 'history-donate'
                      ? 'border-[#234093] text-[#234093]'
                      : 'border-transparent'
                  } `}
                  onClick={() => setActiveTab('history-donate')}
                >
                  Donate
                </div>
              )}
              {promoCard && (
                <div
                  className={`cursor-pointer  inline-block  py-3 leading-8 px-4 font-semibold text-base border-b-2 ${
                    activeTab === 'promo'
                      ? 'border-[#234093] text-[#234093]'
                      : 'border-transparent'
                  } `}
                  onClick={() => setActiveTab('promo')}
                >
                  Quảng bá
                </div>
              )}
              {collab?.visible && (
                <div
                  className={`cursor-pointer  inline-block  py-3 leading-8 px-4 font-semibold text-base border-b-2 ${
                    activeTab === BRAND_COLLAB_TAB
                      ? 'border-[#234093] text-[#234093]'
                      : 'border-transparent'
                  } `}
                  onClick={() => setActiveTab(BRAND_COLLAB_TAB)}
                >
                  {BRAND_PROFILE_COPY.tabLabel}
                </div>
              )}
              <div
                className={`cursor-pointer  inline-block  py-3 leading-8 px-4 font-semibold text-base border-b-2   ${
                  activeTab === 'friend'
                    ? 'border-[#234093] text-[#234093]'
                    : 'border-transparent'
                } `}
                onClick={() => {
                  setActiveTab('friend');
                  // navigate(userId ? `/friend/${userId}` : `/friend/${_get(profile, 'username', '')}`);
                }}
              >
                Bạn bè
              </div>

              {/* <div
                className={`cursor-pointer  inline-block  py-3 leading-8 px-4 font-semibold text-base border-b-2   ${
                  activeTab === 'group'
                    ? 'border-[#234093] text-[#234093]'
                    : 'border-transparent'
                } `}
                onClick={() => setActiveTab('group')}
              >
                Cộng đồng
              </div> */}
            </nav>
            {renderContent(activeTab)}
          </div>

          <div className="mt-[55px] h-fit sticky top-[84px]">
            {profile?.userId ? (
              <CreatorAdCard placement="Profile" creatorId={profile.userId} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
